'use strict';

/*!
 * Here comes description.
 *
 * @package tokai-univ
 * @deps jquery, masonry
 */
const $ = jQuery;

/*!
 * @deps jquery, jquery-effects-core
 */

//elements
const body = $( 'body' );
//values
const ua = window.navigator.userAgent.toLowerCase();
const isiOS = ua.indexOf( 'iphone' ) > -1 || ua.indexOf( 'ipad' ) > -1 || ( ua.indexOf( 'macintosh' ) > -1 && 'ontouchend' in document );
let scrollPosition;

//ios modal scroll control
function iosModalScroll( state ) {
	if ( state === 'false' ) {
		if ( isiOS ) {
			scrollPosition = window.pageYOffset;
			body.css( 'position', 'fixed' );
			body.css( 'top', '-' + scrollPosition + 'px' );
		}
		body.addClass( 'off' );
	} else {
		if ( isiOS ) {
			body.css( 'position', '' );
			body.css( 'top', '' );
			$( window ).scrollTop( scrollPosition );
		}
		body.removeClass( 'off' );
	}
}

//fixed top scroll & header scroll event
let scrollFlag = false;
const fixedControl = $( '.js-fixed-control' );
$( window ).on( 'scroll resize', function () {
	//elements
	const siteHeader = $( '.site-header' );
	const siteHeaderHeight = siteHeader.outerHeight();
	const fixedScrollBtn = $( '.fixed-scroll-top' );
	const primarySiteNav = $( '#site-primary-navigation' );
	const siteFooter = $( '.site-footer' );
	const siteCredit = $( '.site-credits' );
	//values
	let scrollTop = $( window ).scrollTop();
	let documentHeight = $( document ).height();
	let scrollPos = $( window ).height() + $( window ).scrollTop();
	let footerCreditHeight = siteCredit.outerHeight();

	if ( scrollFlag ) clearTimeout( scrollFlag );

	scrollFlag = setTimeout( function () {
		if ( scrollTop > siteHeaderHeight + 10 ) {
			siteHeader.addClass( 'fixed' );
			fixedScrollBtn.addClass( 'active' );
			primarySiteNav.addClass( 'hide' );
			//fixed control switch
			if ( documentHeight - scrollPos <= siteFooter.outerHeight() ){
				fixedControl.attr( 'aria-hidden', 'true' );
			} else {
				fixedControl.attr( 'aria-hidden', 'false' );
			}
			//top scroll btn switch
			if ( documentHeight - scrollPos <= footerCreditHeight ){
				fixedScrollBtn.css( {
					'position': 'absolute',
					'bottom': footerCreditHeight + 30,
				} );
			} else {
				fixedScrollBtn.css( {
					'position': 'fixed',
					'bottom': '',
				} );
			}
		} else {
			siteHeader.removeClass( 'fixed' );
			fixedScrollBtn.removeClass( 'active' );
			primarySiteNav.removeClass( 'hide' );
		}
	}, 10 );

} );

//page scroll
const scrollSpeed = 1000;
//scroll top
$( '.js-scrolltop' ).on( 'click keypress', function () {
	$( 'html, body' ).animate( {
		scrollTop: body.offset().top,
	}, scrollSpeed, 'easeInOutCubic' );
} );
//page smooth scroll
let fromHeadMargin;
$( '.js-scroll-link, .js-scroll-link a' ).on( 'click keypress', function () {
	const scrollTargetElm = $( this ).attr( 'href' );
	fromHeadMargin = $( this ).attr( 'hmargin' );
	if ( fromHeadMargin == null ) {
		fromHeadMargin = 50;
	}
	const hash = scrollTargetElm === '#' || scrollTargetElm === '' ? 'html' : scrollTargetElm;
	const scrollTarget = $( hash );
	const headHeight = $( '.site-header' ).outerHeight();
	const targetPosition = scrollTarget.offset().top;
	$( 'html, body' ).animate( {
		scrollTop: targetPosition - headHeight - fromHeadMargin,
	}, scrollSpeed / 2, 'easeInOutCubic' );
	return false;
} );

//accordion tabindex
$( window ).on( 'load', function () {
	$( '.js-accordion-trigger' ).each( function () {
		if ( ! $( this ).is( '[tabindex]' ) ) {
			$( this ).attr( 'tabindex', '0' );
		}
		if ( $( this ).hasClass( 'opened' ) ) {
			$( this ).next( '.js-accordion-content' ).css( 'display', 'block' );
		}
	} );
} );

//accordion open/close
$( '.js-accordion-trigger' ).on( 'click keypress', function () {
	const slideSpeed = 200;
	const accordionContent = $( this ).next( '.js-accordion-content' );

	if ( $( this ).hasClass( 'opened' ) ) {
		accordionContent.slideUp( slideSpeed );
	} else {
		accordionContent.slideDown( slideSpeed );
	}
	$( this ).toggleClass( 'opened' );

	return false;
} );

//table block class
$( window ).on( 'load', function () {
	$( 'table' ).each( function () {
		if ( $( this ).children( 'thead' ).length ) {
			$( this ).addClass( 'has-thead' );
		}
		if ( $( this ).children( 'tfoot' ).length ) {
			$( this ).addClass( 'has-tfoot' );
		}
	} );
} );

//mobile table block slide
$( '.slide-table > div' ).scroll( function () {
	const slideScroll = $( this ).scrollLeft();
	const shadowOutPoint = $( this ).find( 'table' ).outerWidth() - $( window ).innerWidth() + 20;
	if ( slideScroll >= shadowOutPoint ) {
		$( this ).parent( '.slide-table' ).addClass( 'no-shadow' );
	} else {
		$( this ).parent( '.slide-table' ).removeClass( 'no-shadow' );
	}
} );

//search form open/close
const headerSearchBox = $( '#search-form-area' );
const headerSearchInput = $( '#search-form-area .search-field' );
let headerSearchBoxStates;
$( '.js-header-search-switch' ).on( 'click keypress', function () {
	headerSearchBoxStates = $( this ).attr( 'aria-expanded' );
	if ( headerSearchBoxStates === 'false' ) {
		if ( fixedControl.length ) {
			fixedControl.css( {
				'opacity': '0',
				'pointerEvents': 'none',
			} );
		}
		headerSearchInput.focus();
	} else if ( headerSearchBoxStates === 'true' ) {
		if ( fixedControl.length ) {
			fixedControl.css( {
				'opacity': '1',
				'pointerEvents': 'all',
			} );
		}
		headerSearchInput.blur();
	}
	iosModalScroll( headerSearchBoxStates );
	headerSearchBox.attr( 'aria-hidden', headerSearchBoxStates );
} );

//modal common js
let modalBoxStates;
let modalBoxTarget;
$( '.js-modal-trigger' ).on( 'click keypress', function () {
	modalBoxStates = $( this ).attr( 'aria-expanded' );
	modalBoxTarget = '#' + $( this ).attr( 'aria-controls' );
	if ( modalBoxStates === 'false' ) {
		if ( fixedControl.length ) {
			fixedControl.css( {
				'opacity': '0',
				'pointerEvents': 'none',
			} );
		}
	} else if ( modalBoxStates === 'true' ) {
		if ( fixedControl.length ) {
			fixedControl.css( {
				'opacity': '1',
				'pointerEvents': 'all',
			} );
		}
	}
	iosModalScroll( modalBoxStates );
	$( modalBoxTarget ).attr( 'aria-hidden', modalBoxStates );
} );

//Search select checkbox for news posts
let searchVal;
let searchRedirectUrl;
$( '#news-entry-include' ).on( 'change', function () {
	const baseurl = window.location.protocol + '//' + window.location.host + '/';
	const searchKey = getParam( 's', window.location.href );
	if ( searchKey === null ) {
		searchVal = '?s=';
	} else {
		searchVal = '?s=' + searchKey;
	}
	if ( $( this ).prop( 'checked' ) ) {
		searchRedirectUrl = baseurl + searchVal + '&news=true';
	} else {
		searchRedirectUrl = baseurl + searchVal;
	}
	window.location.href = searchRedirectUrl;
} );

$( window ).on( 'load', function () {
	const newsSearchStatus = getParam( 'news', window.location.href );
	if ( newsSearchStatus === 'true' ) {
		$( '#news-entry-include' ).prop( 'checked', true );
	}
} );

//get url parameter value
function getParam( name, url ) {
	if ( ! url ) url = window.location.href;
	name = name.replace( /[[\]]/g, '\\$&' );
	const regex = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)' ),
		results = regex.exec( url );
	if ( ! results ) return null;
	if ( ! results[2] ) return '';
	return decodeURIComponent( results[2].replace( /\+/g, ' ' ) );
}
